











import defaultComponent from "@vuetifyx/utils/defaultComponent";
import Header from "../Header.vue";
export default defaultComponent.apply({
  components: {
    Header,
  },
  props: [],
  data() {
    return {
    };
  },
  methods: {
    initialize() {
    }
  },
  extraOptions: {
    defaultClass: "defaultLayout"
  }
});
